@if (meeting$ | async; as meeting) {
    @if (meetingUrl$ | async; as linkObject) {
        <div class="link-team-meeting-directive">
            <span adaptTooltip="Meeting"
                  class="link-meeting-badge me-1"></span>
            <a [routerLink]="linkObject.path"
               [queryParams]="linkObject.queryParams">{{ meeting.name }}</a>
        </div>
    }
}
